import Form from "./Form"
import Header from "./Header"
import InputExtra from "./InputExtra"
import EntityForm from "./EntityForm"
import BackButton from "./Form/BackButton"
import SubmitButton from "./Form/SubmitButton"
import getFormSchema from "./Form/getFormSchema"
import optimizeMutation from "./Form/helpers/optimizeMutation"
import FormNavigationFooter from "./Form/FormNavigationFooter"

export * from "./FormItem/types"
export * from "./FormItem/shapes"
export * from "./Form/helpers"
export * from "./Input"

export default Form

export {
  Form,
  Header,
  InputExtra,
  EntityForm,
  BackButton,
  SubmitButton,
  getFormSchema,
  optimizeMutation,
  FormNavigationFooter,
}
